import ActivatedRemoveFromListPanel from "../../components/table-actions-panel/ActivatedRemoveFromListPanel/ActivatedRemoveFromListPanel";
import withActivatedRemoveFromListPanelTracking from "./withActivatedRemoveFromListPanelTracking";

const ActivatedRemoveFromListPanelTracked = withActivatedRemoveFromListPanelTracking(ActivatedRemoveFromListPanel);

export default ActivatedRemoveFromListPanelTracked;
